import Vue from 'vue'
import App from './App.vue'
import router from './router' // 路由
import store from './store/index' // vuex
import { v3, v4 } from '@/api' // vuex
import VueI18n from 'vue-i18n'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/font/iconfont.css'
import { messages } from '@/assets/js/data' // 语言包
import findKey from 'lodash/findKey.js' // 多语言相关组件
import { getOrigin, normalizeThemeMode } from '@/utils/getUserAgent' // 全局注册组件
import Cookies from 'js-cookie'
import axios from 'axios'

import { Divider, Icon, Toast, Dialog, Notify, PasswordInput, Form, Field, NumberKeyboard, DatetimePicker, Picker, Swipe, SwipeItem, Popup, Popover, ImagePreview, Lazyload, SwipeCell, Tab, Tabs, Overlay } from 'vant'
import 'vant/lib/index.css'
import '@/assets/css/tailwind.css'
import '@/assets/css/reset.css'
import '@/utils/global'
import '@/utils/matomo' // matomo 埋点：注册 Vue.prototype.matomofn
import 'hammerjs'

Vue.prototype.$Dialog = Dialog
Vue.prototype.$Toast = Toast
Vue.prototype.$Notify = Notify
Vue.prototype.$axios = axios

Vue.use(Divider)
Vue.use(Icon)
Vue.use(Form)
Vue.use(Field)
Vue.use(Tab)
Vue.use(Tabs)
Vue.use(Overlay)
Vue.use(SwipeCell)
Vue.use(Lazyload)
Vue.config.productionTip = false
Vue.use(PasswordInput)
Vue.use(NumberKeyboard)
Vue.use(DatetimePicker)
Vue.use(Dialog)
Vue.use(Picker)
Vue.use(Swipe)
Vue.use(SwipeItem)
Vue.use(Popup)
Vue.use(Popover)
Vue.use(ImagePreview)
Vue.use(VueI18n)
Vue.prototype.$cookies = Cookies // 设置cookie
Vue.prototype.$store = store // vuex
Vue.prototype.$v3 = v3 // vuex
Vue.prototype.$v4 = v4 // vuex

Vue.use(ElementUI)
const commit = Vue.prototype.$store
// 处理域名
if (window.location.host.includes('.com')) {
  // 设置获取主域名
  const host = window.location.host.split('.').splice(1, 2)
  commit.commit('base/sethost', host.join('.'))
}

let getdata = {}
const appagentparam = getOrigin() // app进来的数据test
console.log(appagentparam, 8866555)
commit.commit('base/setFxint', appagentparam?.fxintl ?? appagentparam?.fxint ?? '')
commit.commit('base/setThemeMode', normalizeThemeMode(appagentparam?.themeMode))

let lang = '' // 定义语言
const langList = store.state.base.langList
// console.log('langList: ', langList);
lang = window.location.href.replace('http://', '').replace('https://', '').split('/')[1].split('?')[0]
console.log('lang: ', lang)
// ---取浏览器语言
let navlang = navigator.language.split(',')[0].toLowerCase()
console.log('navlang: ', navlang)
if (navlang != 'zh-cn' && navlang.includes('-')) {
  navlang = navlang.split('-')[0]
}
if (!langList.includes(navlang)) navlang = 'en'
console.log('store.state.base.langList.includes(lang): ', store.state.base.langList.includes(lang))

// ---------------------------------
lang = lang && store.state.base.langList.includes(lang) ? lang.toLocaleLowerCase() : navlang ? navlang : 'en'
if (lang === 'zh-tw' || lang === 'zh-hk') {
  lang = 'zh'
  window.location.href = `/${lang}`
}
if (appagentparam?.BasicData) {
  // 判断如果为app传入contentcookie则使用app数据
  commit.commit('base/set_appBasicData', appagentparam?.BasicData)
  Object.assign(getdata, appagentparam)
  const userInfo = {
    userId: getdata?.userId || '',
    nick: getdata?.nick || '',
    avatar: getdata?.avatar || '',
    email: getdata?.email || '',
    phone: getdata?.phone || ''
  }
  console.log('userInfo: app 传值', userInfo)
  commit.commit('base/setisApp', true)
  commit.commit('base/setUser', userInfo)
  commit.commit('base/setThemeMode', normalizeThemeMode(appagentparam?.themeMode))

  const navHeight = parseFloat(getdata.navHeight).toFixed(2)

  commit.commit('base/getNavHeight', navHeight) // 设置为APP

  commit.commit('base/setwikinum', getdata?.wikinum) // 设置天眼号
  commit.commit('base/setCountryCode', getdata?.countrycode) // 设置国家
  commit.commit('base/setMyCountry', getdata?.myCountry) // 设置ip国家
  commit.commit('base/setLangCode', getdata.language.toLowerCase()) // 存入当前语言
  lang = getdata.language.toLowerCase()
  let base = appagentparam?.BasicData.split(',')
  console.log('base: ', base)
  if (base && base[2]) {
    console.log('base[2]', base[2])
    if (base[2] == 600) commit.commit('base/setappbase', 'LemonX')
    else if (base[2] == 700 || base[2] == 701) commit.commit('base/setappbase', 'GoldenEye')
    else if (base[2] == 1000) commit.commit('base/setappbase', 'WikiBit')
    else commit.commit('base/setappbase', 'WikiFX')
  }

  if (base && base[3]) {
    commit.commit('base/setAppVersion', base[3])
    console.log(store.state.base.appVersion, '版本号??')
  }

  let countries = null
  const areaCode = getdata?.area || '0086'
  console.log('areaCode::: ', areaCode)
  if (areaCode) {
    if (['zh-cn', 'zh', 'zh-tw', 'zh-hk'].includes(lang?.toLowerCase())) {
      countries = require('@/static/json/areaCodeCN.json')
    } else {
      countries = require('@/static/json/areaCodeEn.json')
    }
    const normalizeAreaCode = (value) => `${value || ''}`.replace(/^0+/, '')
    const flatCountries = countries.reduce((list, item) => {
      if (item?.data?.length) {
        return list.concat(item.data)
      }
      return list
    }, [])
    const matchCountry = flatCountries.find((item) => {
      return item.code === areaCode || normalizeAreaCode(item.code) === normalizeAreaCode(areaCode)
    })

    if (matchCountry) {
      commit.commit('base/setuserCountInfo', matchCountry)
    }
  }
} else {
  commit.commit('base/setLangCode', lang) // 存入当前语言
}

const channeltest = new URLSearchParams(window.location.search).get('channeltest')
if (channeltest) {
  const channelMap = {
    wikifx: 'WikiFX',
    wikibit: 'WikiBit',
    lemonx: 'LemonX',
    goldeneye: 'GoldenEye'
  }
  const channel = channelMap[channeltest.toLowerCase()]
  if (channel) commit.commit('base/setappbase', channel)
}

if (getdata.userId) commit.commit('base/setUserid', getdata.userId) // 设置userid
if (getdata.pkgName) commit.commit('base/set_pkgName', getdata.pkgName) // wikiGload标识符
// ...对数据进行存储

const i18n = new VueI18n({
  locale: lang,
  messages,
  silentTranslationWarn: true
})
VueI18n.prototype.translation = function (value) {
  let en = require('@/assets/languages/TXT_zh-CN.json')
  let val = findKey(en, function (o) {
    return o === value
  })
  if (!val) {
    return value + '(前端未翻译)'
  }
  return this.$t(val)
}
Vue.prototype.$v = i18n.translation // i18n
document.querySelector('html').setAttribute('lang', lang)
i18n.location = lang
if (['ar', 'ur'].includes(lang)) {
  document.querySelector('html').setAttribute('dir', 'rtl')
} else {
  document.querySelector('html').setAttribute('dir', 'ltr')
}
new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App)
}).$mount('#app')
